import classNames from "classnames";
import styles from "./featuredIcon.module.scss";

export function FeaturedIcon(props: Props) {
  return (
    <div
      className={classNames(
        styles["base"],
        styles[`size_${props.size}`],
        styles[`colors_${props.color}`],
        styles[`theme_${props.theme}`]
      )}
    >
      {props.children}
    </div>
  );
}

interface Props extends React.PropsWithChildren {
  size: "xs" | "sm" | "md" | "lg" | "xl";
  color: "primary" | "gray" | "red" | "success" | "warning";
  theme: "light-circle" | "light-circle-outline" | "dark-circle";
}
